import $ from 'jquery';
import lozad from 'C:\\Program Files (x86)\\Microsoft VS Code\\bin\\node_modules\\lozad';
import LinkController from './LinkController';
import ImageCreditsController from './ImageCreditsController';
import CookiesController from './CookiesController';

class LazyLoadingController {
    constructor(scrollingContent, topN, count, path, nestingLevel, whereStatement, 
        orderBy, classNames, textBackgroundColor, totalPages, paramName, btnLoadMore,
        restorePageState) {
        this.lastScroll = 0;
        this.totalPages = totalPages; // provided from the back end PagerControl.PageCount
        this.currentPage = 0;
        this.url = ''; // url of the page including any params
        this.paramName = paramName; // provided from the web part Query String Key
        this.nextDataPage = 0; // replaced when loading more
        this.prevDataPage = 0; // replaced when loading more
        this.nextDataCache = '';
        this.isLoading = false; // simple lock to prevent loading when loading
        this.ScrollingContentID = `#${scrollingContent.id}`;
        this.topN = topN;
        this.count = count;
        this.path = path;
        this.nestingLevel = -1;
        this.whereStatement = whereStatement;
        this.orderBy = orderBy;
        this.classNames = classNames;
        this.textBackgroundColor = textBackgroundColor;
        this.btnLoadMore = btnLoadMore;
        this.restorePageState = restorePageState;

        $(scrollingContent).find('.PagerControl').remove();
        this.InitLazyLoad();
    }

    storePageState(page) {
        CookiesController.createCookie("SOS_" + window.location.pathname + this.ScrollingContentID, page, -1);
    }

    getLastPage() {
        const page = CookiesController.readCookie("SOS_" + window.location.pathname + this.ScrollingContentID);
        if (typeof page === "undefined" || !page)
            return 0;
        const iPage = parseInt(page);
        if (isNaN(iPage))
            return 0;
        return iPage;
    }

    loadPages(firstPage, lastPage) {
        let currPage = firstPage;
        $(`${this.ScrollingContentID} div.scrollingcontentblock:last`).after($(this.nextDataCache).hide().fadeIn());
        LinkController.registerClickEventForElement(`${this.ScrollingContentID} div.scrollingcontentblock:last`);
        if (currPage <= lastPage) {
            const that = this;
            this.loadPage(currPage, function() {
                currPage += 1;
                if (currPage <= lastPage) {
                    that.loadPages(currPage, lastPage);
                }
            })
        }
    }

    loadPage(page, callback) {
        let that = this;
        LatestNews.GetLatestNews(this.topN, page, this.count, this.path, this.nestingLevel, // eslint-disable-line no-undef
            this.whereStatement, this.orderBy, this.classNames, this.textBackgroundColor, (data) => {
            // parse & append the data
                that.nextDataCache = LazyLoadingController.parseHTML(data, page + 1);
                // End loading
                that.isLoading = false;
                that.currentPage = page;
                const observer = lozad(); // lazy loads elements with default selector as '.lozad'
                observer.observe();
                if (that.currentPage >= that.totalPages) {
                    $(that.btnLoadMore).hide();
                }
                ImageCreditsController.init();
                callback();
            }, (data) => {
                console.log(`GetLatestNews error: ${JSON.stringify(data)}`);
                callback();
            });
    }

    getTeasers() {
        LatestNews.GetLatestNews(this.topN, this.nextDataPage, this.count, this.path, this.nestingLevel, // eslint-disable-line no-undef
            this.whereStatement, this.orderBy, this.classNames, this.textBackgroundColor, (data) => {
            // parse & append the data
                this.nextDataCache = LazyLoadingController.parseHTML(data, this.nextDataPage);
                // End loading
                this.isLoading = false;
                this.currentPage += 1;
                const observer = lozad(); // lazy loads elements with default selector as '.lozad'
                observer.observe();
                if (this.currentPage >= this.totalPages) {
                    $(this.btnLoadMore).hide();
                }
                ImageCreditsController.init();
            }, (data) => {
                console.log(`GetLatestNews error: ${JSON.stringify(data)}`);
            });
    }

    InitLazyLoad() {
        $(window).scroll(() => {
            this.scrollPos = $(window).scrollTop();
        });

        this.url = window.location.href;

        if (this.nextDataPage <= this.totalPages) {
            // Load next page into cache
            this.isLoading = true;
            this.nextDataPage = this.currentPage + 1;
            if (this.restorePageState) {                
                const lastPage = this.getLastPage();
                if (lastPage > 1)
                    this.loadPages(1, lastPage);
            }
            this.getTeasers();
        }
        else {
            $(this.btnLoadMore).hide();
        }

        // lazy button click to load more
        $(this.btnLoadMore).click(() => {
            if (!this.isLoading) {
                // append the cached next page
                $(`${this.ScrollingContentID} div.scrollingcontentblock:last`).after($(this.nextDataCache).hide().fadeIn());
                // parse links
                LinkController.registerClickEventForElement(`${this.ScrollingContentID} div.scrollingcontentblock:last`);
                // then load the next cache
                this.nextDataPage = this.currentPage + 1;
                if (this.nextDataPage <= this.totalPages) {
                    // Load next page into cache
                    this.isLoading = true;
                    this.getTeasers();
                    this.storePageState(this.nextDataPage);
                }
                else {
                    $(this.btnLoadMore).hide();
                }
            }
        });
    }

    // Since the whole page is returned - we just need the new page data
    static parseHTML(data, pg) {
        let contents = data;
        // update the page num
        contents = $(`${contents}.scrollingcontentblock`).attr('data-page', pg);
        return contents;
    }

    static mostlyVisible(element) {
        // if ca 25% of element is visible
        const scrollPos = $(window).scrollTop();
        const windowHeight = $(window).height();
        const elTop = $(element).offset().top;
        const elHeight = $(element).height();
        const elBottom = elTop + elHeight;
        return ((elBottom - elHeight * 0.25 > scrollPos)
            && (elTop < (scrollPos + 0.5 * windowHeight)));
    }

    static init(scrollingContentID, topN, count, path, nestingLevel, whereStatement, 
        orderBy, classNames, textBackgroundColor, totalPages, paramName, btnLoadMore,
        restorePageState = false) {
        new LazyLoadingController(scrollingContentID, topN, count, path, nestingLevel, 
            whereStatement, orderBy, classNames, textBackgroundColor, totalPages, paramName, 
            btnLoadMore, restorePageState); // eslint-disable-line no-new
    }
}

window.LazyLoadingController = LazyLoadingController;
export default LazyLoadingController;
